import { useProjectUserRoles } from '@contember/react-identity'

/** The three product areas the admin is split into — one nav tab each. */
export type AdminSection = 'cms' | 'sn' | 'gd'

export function adminSectionForPath(pathname: string): AdminSection {
	if (pathname === '/gd' || pathname.startsWith('/gd/')) return 'gd'
	if (pathname.startsWith('/cms/')) return 'cms'
	return 'sn'
}

/**
 * Which areas the signed-in identity may open: `editor` is the CMS-only role,
 * everything else (kurzy, přihlášky, Grantový diář) is admin territory.
 *
 * This is chrome, not enforcement — the ACL is what actually stops an editor
 * reading an order. It keeps the admin from offering doors that open onto an
 * empty room.
 *
 * An empty role set means we are not behind the tenant identity at all: local
 * dev authenticates with the project's root token, whose `me` carries no
 * memberships. That unlocks everything rather than locking the developer out.
 */
export function useAdminSectionAccess(): (section: AdminSection) => boolean {
	const roles = useProjectUserRoles()
	const isCmsOnly = roles.size > 0 && !roles.has('admin')
	return section => !isCmsOnly || section === 'cms'
}
